import React, { useImperativeHandle, useState, useRef, useEffect } from "react";
import { MeasureLeaderboardWarningDialog } from "@icoach/measureLeaderboard";
import { isEqual } from "@util/utils";

const MeasureLeaderboardDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState(null);
	const [sourceData, setSourceData] = useState(null);
	const refreshRef = useRef(null);

	const handleCloseDialog = () => {
		setOpenDialog(false);
	};

	useImperativeHandle(
		ref,
		() => {
			return {
				openMeasureLeaderboardWarningDialog: () => {
					setOpenDialog("MeasureLeaderboardWarning");
				},
				closeDialog: () => handleCloseDialog(),
			};
		},
		// eslint-disable-next-line
		[]
	);

	useEffect(
		() => {
			if (!openDialog) {
				refreshRef.current = null;
				setSourceData(null);
			}
		},
		// eslint-disable-next-line
		[openDialog]
	);

	if (!openDialog) return null;
	return (
		<React.Fragment>
			<MeasureLeaderboardWarningDialog open={isEqual(openDialog, "MeasureLeaderboardWarning")} onClose={handleCloseDialog} sourceData={sourceData} />
		</React.Fragment>
	);
});

export default MeasureLeaderboardDialogBox;
